module.exports = __webpack_public_path__ + "static/media/opsd.dae0c17e.png";